import {doc} from '../docs.js';
import MidiTrigger from "effects/midi/MidiTrigger.js";
import StepData from "pattern/StepData.js";
import {TRIGGER, TICK} from "messaging/message-types.js";
import TidalEffect from "effects/midi/TidalEffect.js";

doc(
    "tidal",
    {
    },
    "A tidal sequencer that sends triggers out",
    undefined,
    {
    }
);

export const tidal = (object) => {
    object.needsTick = true;
    let effect = new TidalEffect(object.subSequence, undefined, object);
    effect.subSequence = object.subSequence;
    object.effect = effect;
    let stepData = new StepData();
    stepData.loadDefaults();
    stepData.velocity = 0.5;
    stepData.duration = 1000000;

    return ([type, ...args]) => {
        switch (type) {
        case "restart":
            // restart on the current step number
            // effect.stepNumberTriggered = object.sequencerEngine.trackStep;
            break;
        case TICK:
            let [stepNumber, time] = args;
            effect.onNewStep(stepNumber, time);
            if (stepNumber === 0) {
                // get a new step of infinite duration and
                // send thru the jaki effect
                let trigger = new MidiTrigger(
                    stepData, time, stepNumber);
                effect.input(trigger);
            }

            let triggers = effect.output(time, stepNumber, stepNumber);
            triggers.forEach(x => {
                x.stepData.time = x.time;
                x.stepData.stepNumber= x.stepNumber;
                x.outputNumber = 1;
            });
            triggers.forEach(
                ({stepData}) => {
                    object.sendMessage(object.outputByNumber(0), stepData);
                });
        }
    };
};

doc(
    "outputNumber",
    {
        n: "Slot number to send output"
    },
    "Sends triggers to specific slot in the pad (1-9)",
    undefined,
    {
        inlets: 2
    }
);
export const outputNumber = (object, n) => {
    return ([msg]) => {
        if (msg[0] === TRIGGER) {
            let triggers = msg[1];
            triggers = triggers.map(
                x => ({
                    ... x,
                    outputNumber: n() || 1
                }));
            return [[TRIGGER, triggers]];
        }
    };
};
